import NextImage from 'next/image';
import { useRouter } from 'next/router';

import { Typography, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import AnnouncementDegree from './announcementDegree';
import { Container, HeaderStyle, ImageWrapper } from './style';

import Image from '@components/atoms/image';
import { getNamespaces } from '@helpers/i18nUtils';
import { useDegreeLandingPageData } from '@helpers/use';

const Header = () => {
  const theme = useTheme();
  const router = useRouter();
  const degreeIdName = (router.query.degreeIdName as string) || '';
  const { t } = useTranslation(getNamespaces({ namespaces: [degreeIdName] }));

  const universityId = router.query.universityIdName as string;

  const { landingPage } = useDegreeLandingPageData(universityId, degreeIdName);

  return (
    <>
      {landingPage?.degreeAlertFlag && <AnnouncementDegree degreeAlertFlag={landingPage.degreeAlertFlag} />}
      <HeaderStyle>
        <Container>
          {landingPage?.universityLogoImageUrl && (
            <Image
              style={{ height: 25, width: 'auto' }}
              src={landingPage?.universityLogoImageUrl}
              alt="University logo"
            />
          )}

          <Typography variant="h1">
            {t('degree_landing_page.header.title', { degreeName: landingPage?.degreeName })}
          </Typography>
          <Typography
            variant="h3"
            sx={{
              [theme.breakpoints.down('md')]: {
                fontSize: 24,
                fontWeight: 500,
              },
            }}
            mb={2}
            lineHeight="24px"
          >
            {landingPage?.majorName} {landingPage?.majorSubject}
          </Typography>
          <Typography
            variant="h6_deprecated"
            sx={{
              [theme.breakpoints.down('md')]: {
                fontWeight: 500,
              },
            }}
            lineHeight="24px"
          >
            {t('degree_landing_page.header.degree_alias_name', { degreeAliasName: landingPage?.degreeAliasName })}
          </Typography>
        </Container>
        <ImageWrapper>
          {landingPage && landingPage?.degreeBannerUrl && (
            <NextImage src={landingPage?.degreeBannerUrl} layout="fill" objectFit="cover" />
          )}
        </ImageWrapper>
      </HeaderStyle>
    </>
  );
};

export default Header;
